import Vue from 'vue';
import adjustmentTransformer from './../../transformers/adjustment';
import store from '../../store';

const success = ({ data }, resolve) => {
  const adjustment = adjustmentTransformer.fetch(data);
  resolve(adjustment);
  store.dispatch('fetchCurrentAdjustment', adjustment);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/adjustments/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/show.js